<template>
	<div>
		<winning-numbers-sidebar :open.sync="sidebarOpen" :results="externalLotteriesResults"></winning-numbers-sidebar>
		<v-btn id="external-results-btn" @click="sidebarOpen = !sidebarOpen" style="z-index: 4">
			Winning Numbers
		</v-btn>
		<v-row>
			<v-img contain height="200" :src="require('@/assets/img/easymoney/logo.png')"></v-img>
		</v-row>
		<v-row justify="center">
			<v-col cols="auto">
				<v-btn id="see-it-live-btn" color="primary" @click="scrollToStream">
					Check our livestream
				</v-btn>
			</v-col>
		</v-row>
		<v-row justify="center">
			<v-col cols="auto">
				<h1 class="white--text">Lastest results</h1>
			</v-col>
		</v-row>
		<v-row justify="center" class="mb-5">
			<v-col
				xl="2"
				lg="3"
				md="4"
				sm="6"
				cols="12"
				:class="{ 'pa-1': $vuetify.breakpoint.smAndDown }"
				v-for="(result, index) in results"
				:key="`${result.date}-${result.sortition.id}`"
			>
				<card class="result-card rounded-xl" :class="{'last-winning': index === 0}" :result="result"
							:display-as-one="false"
							:pick-three-image="{ src: require('@/assets/img/easymoney/pickThree_w.png'), width: '90px', height: '50px',contain: true }"
							:pick-four-image="{ src: require('@/assets/img/easymoney/pickFour_w.png'), width: '90px', height: '50px', contain: true }">
					<template #sortition-area="{date, sortition}">
						<v-row align="center">
							<v-col md="12">
								<v-img contain height="150" :src="require('@/assets/img/easymoney/logo_board.png')"></v-img>
							</v-col>
							<v-col md="12">
								<h2 class="sortition-name">{{ sortition.name }}</h2>
								<h5 class="mb-0">
									{{ date }}
								</h5>
							</v-col>
						</v-row>
					</template>
					<template #first-second-third="{result, displayAsOne, imageDimensions}">
						<v-row class="flex-column align-center" no-gutters>
							<v-col cols='auto' class='d-flex align-center'>
								<h2 class="mx-5">
									1st
								</h2>
								<digit-image-display :display-as-one="displayAsOne" class='d-flex' :digit='result.first'
																		 :image-dimensions='imageDimensions'/>
							</v-col>
							<v-col cols='auto' class='d-flex align-center'>
								<h2 class="mx-5">
									2nd
								</h2>
								<digit-image-display :display-as-one="displayAsOne" class='d-flex' :digit='result.second'
																		 :image-dimensions='imageDimensions'/>
							</v-col>
							<v-col cols='auto' class='d-flex align-center'>
								<h2 class="mx-5">
									3rd
								</h2>
								<digit-image-display :display-as-one="displayAsOne" class='d-flex' :digit='result.third'
																		 :image-dimensions='imageDimensions'/>
							</v-col>
						</v-row>
					</template>
				</card>
			</v-col>
		</v-row>

		<v-responsive :aspect-ratio="16 / 9">
			<iframe
				v-if="channelName && channelName.length > 0"
				id="frame"
				:src="
          `https://player.twitch.tv/?channel=${channelName}&parent=easylottery.tv&parent=localhost`
        "
				frameborder="0"
				scrolling="no"
				allowfullscreen="true"
			>
			</iframe>
		</v-responsive>
	</div>
</template>

<script>
import BaseStream from "@homepage/components/pageStyles/BaseStream";
import {generateSimpleImageMapFor} from "@homepage/helpers/image";
import Card from "@homepage/components/streams/cards/Card.vue";
import DigitImageDisplay from "@homepage/components/DigitImageDisplay.vue";

export default {
	name: "EasyMoneyStream",
	components: {
		DigitImageDisplay,
		Card
	},
	extends: BaseStream,
	provide() {
		return {
			imagesMap: generateSimpleImageMapFor('easymoney'),
		};
	},
};
</script>

<style scoped lang="scss">
@import './common.scss';

$main-color: #05a551;
$blue: #0017A1;

.result-card {
	color: white;
	border: 4px solid #eac627;
	background-color: $main-color;
	-webkit-backdrop-filter: blur(5px);
	backdrop-filter: blur(5px);
}

.sortition-name {
	word-break: keep-all;
}

.last-winning {
	transition: border, box-shadow;
	box-shadow: 0 0 25px #818181;
}
</style>

<style>

#inspire {
	background-image: url("../../../assets/img/easymoney/background.jpg");
}
</style>
